export const ENV = {
  LOCAL: "local",
  DEV: "dev",
  PROD: "prod",
};
